import { ComponentClass } from 'react';

import InputBase from './Base';
import { CoreFormElementDate } from '../../../components/';

/**
 * Date Input Controller
 * @export
 * @class DateInputController
 * @extends {InputBase}
 */
export default class DateInputController extends InputBase {
  /**
   * Controlled Element
   * @override
   * @static
   * @memberof DateInputController
   */
  public static ControlledElement: ComponentClass<any> = CoreFormElementDate;
}
